"use client";

import { useLayoutEffect } from "react";

/** Shelf Life Wisdom is dark-first editorial; keep blog chrome on dark tokens regardless of app theme. */
export function BlogRootThemeSync() {
  useLayoutEffect(() => {
    document.querySelectorAll(".ed-blog-root").forEach((el) => {
      el.setAttribute("data-blog-theme", "dark");
    });
  }, []);
  return null;
}
